import React, {useEffect, useState} from "react";

function RepresentativesToChooseDialog(props) {

    const [representatives, setRepresentatives] = useState([]);

    useEffect(() => {
        setRepresentatives(props.items.map(item => ({
            ...item,
            selected: false
        })));
    }, [props.items]);

    const selectedItemChangeHandler = (event, index) => {
        const {checked} = event.target;

        let updatedRepresentatives = [...representatives];
        updatedRepresentatives[index] = {...updatedRepresentatives[index], selected: checked};

        setRepresentatives(updatedRepresentatives);
    };

    const chooseButtonClickHandler = () => {
        let selectedRepresentatives = representatives.filter(item => item.selected);

        props.onChoose(selectedRepresentatives);
        props.onClose();
    };

    if (!props.isOpen) {
        return null;
    }

    return (
        <div className="cr-dialog-overlay" onClick={props.onClose}>
            <div className="cr-dialog" onClick={e => e.stopPropagation()}>
                <div className="cr-dialog-header">
                    <h3 className="cr-dialog-title">Wybierz reprezentantów</h3>
                    <button type="button" className="cr-dialog-close" onClick={props.onClose}>✕</button>
                </div>
                <div className="cr-dialog-body">
                    <div className="expert-help-checkboxes">
                        {representatives.map((representative, index) => (
                            <label className="search-checkbox-row" key={index}>
                                <input
                                    type="checkbox"
                                    checked={representative.selected}
                                    onChange={event => selectedItemChangeHandler(event, index)}
                                />
                                <span>{representative.firstName} {representative.lastName}{representative.function ? " - " + representative.function : ""}</span>
                            </label>
                        ))}
                    </div>
                </div>
                <div className="cr-dialog-footer">
                    <button type="button" className="dialog-btn reverse-btn" onClick={props.onClose}>Anuluj</button>
                    <button type="button" className="dialog-btn" onClick={chooseButtonClickHandler}>Wybierz</button>
                </div>
            </div>
        </div>
    );
}

export default RepresentativesToChooseDialog;
